import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Tooltip,
  Descriptions,
  Drawer,
  Button,
  Space,
  Modal,
  List,
  Tag,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../helpers/http";
import helper from "../../helpers/helper";
import config from "../../config/config";
import moment from "moment";
import { useTranslation } from "react-i18next";
function Index() {
  const [loading, setloading] = useState(false);

  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [proData, setProData] = useState({});
  const [proEntries, setProEntries] = useState([]);
  const [drawerOpen, setdraweropen] = useState(false);
  const [isProDrawerOpen, setIsProDrawerOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { t } = useTranslation();

  const moduleNamePural = t("bookings.moduleNamePural");
  const base_url = config.api_url + "admin/bookings"; //without trailing slash
  const image_url = config.api_url + ""; //with trailing slash

  const fetchDatas = async () => {
    setloading(true);
    const data = await http.get(base_url);

    if (data) {
      setDatas(data.data);
    }
    setloading(false);
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      console.log(data);
      setdraweropen(true);
    }
  };
  const handleProView = async (entry_id) => {
    const { data } = await http.get(`${base_url}/pro-entry/${entry_id}`);

    if (data) {
      setProData(data);

      setIsProDrawerOpen(true);
    }
  };
  const handleProModal = async (user_id) => {
    const { data } = await http.get(`${base_url}/pro-entries/${user_id}`);

    if (data) {
      setProEntries(data);

      setIsModalVisible(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };
  const handleProDrawerClose = () => {
    setProData({});
    setIsProDrawerOpen(false);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const fields = {
    paypal_order_id: t("bookings.columns.bookingId"),
   
    start_date: t("bookings.columns.startDate"),
    end_date: t("bookings.columns.endDate"),

    guest: t("bookings.columns.guest"),

    first_name: t("bookings.columns.firstName"),
    last_name: t("bookings.columns.lastName"),
    phone: t("bookings.columns.contactNumber"),
    email: t("bookings.columns.emailAddress"),
    special_request: t("bookings.columns.specialRequest"),
    amount: t("bookings.columns.amount"),
    
  

    createdAt: {
      header: t("bookings.columns.bookedAt"),
      formatter: (_fieldValue, record) => {
        return  `${helper.ISTDate(record.createdAt)}`;
      },
    },
  };

  const columns = [
    {
      title: t("bookings.columns.fullName"),

      key: "name",
      render: (text, record) => {
        return `${record.first_name} ${record.last_name}`;
      },
    },

    {
      title: t("bookings.columns.startDate"),
      render: (text, record) => {
        return helper.ISTDate(record.start_date, "YYYY-MM-DD");
      },
      key: "start_date",
    },
    {
      title: t("bookings.columns.endDate"),
      render: (text, record) => {
        return helper.ISTDate(record.end_date, "YYYY-MM-DD");
      },
      key: "end_date",
    },
    {
      title: t("bookings.columns.contactNumber"),
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: t("bookings.columns.paymentStatus"),

      key: "payment_status",
      render: (text, record) => {
        return record.payment_status == "failed" ? (
          <Tag color="red">{t("bookings.status.failed")}</Tag>
        ) : record.payment_status == "success" ? (
          <Tag color="green">{t("bookings.status.success")}</Tag>
        ) : (
          <Tag color="orange">{t("bookings.status.pending")}</Tag>
        );
      },
    },

    // {
    //   title: "Created At",
    //   render: (text, record) => {
    //     return helper.ISTDate(record.createdAt);
    //   },
    //   key: "createdAt",
    //   sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    // },
    {
      title: t("bookings.columns.action"),
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              handleView(record._id);
            }}
          >
            {t("common.viewDetails")}
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb> */}
      <Breadcrumb
        style={{ margin: "16px 0" }}
        items={[
          {
            title: t("common.dashboard"),
          },

          {
            title: moduleNamePural,
          },
        ]}
      />

      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                exportableProps={{
                  showColumnPicker: false,
                  fields,
                  fileName: moduleNamePural,
                  children:t("common.exportToCsv")
                }}
                searchable
              />
            </Card>

            <Drawer
              title={t("common.moreDetails")}
              placement="right"
              onClose={handleDrawerClose}
              open={drawerOpen}
              size="large"
              width={1000}
            >
              {data && (
                <Descriptions
                  bordered
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                  size="small"
                >
                  <Descriptions.Item label={t("bookings.columns.bookingId")}>
                    {data.paypal_order_id || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("bookings.columns.startDate")}>
                    {helper.ISTDate(data.start_date, "YYYY-MM-DD")}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("bookings.columns.endDate")}>
                    {helper.ISTDate(data.end_date, "YYYY-MM-DD")}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("bookings.columns.guest")}>
                    {data.guest || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("bookings.columns.firstName")}>
                    {data.first_name || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("bookings.columns.lastName")}>
                    {data.last_name || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={t("bookings.columns.contactNumber")}
                  >
                    {data.phone || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("bookings.columns.emailAddress")}>
                    {data.email || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={t("bookings.columns.specialRequest")}
                  >
                    {data.special_request || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("bookings.columns.amount")}>
                    {`€ ${data.amount}` || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={t("bookings.columns.paymentStatus")}
                  >
                    {data.payment_status == "failed" ? (
                      <Tag color="red">{t("bookings.status.failed")}</Tag>
                    ) : data.payment_status == "success" ? (
                      <Tag color="green">{t("bookings.status.success")}</Tag>
                    ) : (
                      <Tag color="orange">{t("bookings.status.pending")}</Tag>
                    )}

                    {/* {data.payment_status || "NA"} */}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("bookings.columns.bookedAt")}>
                    {`${helper.ISTDate(data.createdAt)}`}
                  </Descriptions.Item>
                </Descriptions>
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Index;
